import { Routes } from '@angular/router';
import { StatusComponent } from './modules/status/status.component';
import { FeedbackComponent } from './modules/feedback/feedback.component';

/**
 * Application routes.
 */
export const routes: Routes = [
  {
    path: '',
    component: StatusComponent,
  },
  {
    path: 'feedback',
    component: FeedbackComponent,
  },
];
